<template>
	<div class="row">
    <div class="col-md-12 paginacion">
    	<nav aria-label="Page navigation">
			  <ul class="pagination">
			    <li><router-link :to=" createPaginationLink(actualPage-1) "><span aria-hidden="true"><i class="fa fa-angle-left"></i></span></router-link></li>
			    
			    <template v-if=" totalPages > 10 && actualPage > N+1 ">
						<li><router-link :to=" createPaginationLink(1) " >1</router-link></li>
						<li><a @click.prevent>...</a></li>
					</template>

			    <template v-if=" totalPages <= 10 ">
						<li v-for=" i in totalPages" :key="i"><router-link :to=" createPaginationLink(i) "  :class="[ i ==  actualPage ? 'actual-page' : '']">{{ i }}</router-link></li>
			    </template>	

			    <template v-else>	
						<li v-for=" i in range()" :key="i"><router-link :to=" createPaginationLink(i) "  :class="[ i ==  actualPage ? 'actual-page' : '']">{{ i }}</router-link></li>
						<template v-if=" actualPage < totalPages - N ">
							<li><a @click.prevent>...</a></li>
							<li><router-link :to=" createPaginationLink(totalPages) " >{{ totalPages }}</router-link></li>
						</template>
			    </template>

			    <li><router-link :to=" createPaginationLink(actualPage+1) "><span aria-hidden="true"><i class="fa fa-angle-right"></i></span></router-link></li>
			  </ul>
			</nav>
    </div>
  </div>
</template>

<script>
	import { mapState, mapGetters } from 'vuex';

	export default {
		props: ['totalResults'],
   	data: () => {
			return {
				//resultsPerPage: 0,
				totalPages: 0,
				//actualPage: 0,
				min: 0,
				max: 0,
				rangeArray: [],
				//N: 0,
				//query: []
			}
		},
		beforeMount(){
				//this.resultsPerPage = this.getResultsPerPage;
				//this.actualPage = this.getActualPage;
				this.totalPages = this.get_total_pages();
				//this.N = this.getN;
				//this.query = this.getQuery;
				//this.route = this.$route.query;
		},
		//computed: mapGetters(['getActualPage', 'getResultsPerPage', 'getQuery', 'getN']),
		computed: mapGetters({
			actualPage: 'getActualPage',
			resultsPerPage: 'getResultsPerPage',
			query: 'getQuery', 
			N: 'getN'
		}),
		methods:{
			get_total_pages(){
				return Math.ceil(this.totalResults / this.resultsPerPage);
			},
			createPaginationLink(page){
				page = ( parseInt(page) == 0 ) ? 1 : page;
				page = ( parseInt(page) > this.totalPages ) ? this.totalPages : page;
				var tmp = Object.assign({}, this.query);
				return ( { query: Object.assign(tmp, { p: page }) } );
			},
			range(){
				var j = 0;

				this.min = ( parseInt(this.actualPage) - this.N < 1) ? 1 : ( parseInt(this.actualPage) > parseInt(this.totalPages) - this.N ) ? parseInt(this.totalPages) - 2*this.N : parseInt(this.actualPage) - this.N;
				this.max = ( parseInt(this.actualPage) + this.N > parseInt(this.totalPages) ) ? parseInt(this.totalPages) : ( parseInt(this.actualPage) < this.N+1) ? 2*this.N+1 : parseInt(this.actualPage) + this.N; 
				this.rangeArray.length = 0;

				for(var i = this.min; i <= this.max; i++){
					this.rangeArray[j] = i;
					j++;
				}
				return this.rangeArray;
			}
		},
		watch: {
      actualPage: function() { 
        this.actualPage = this.getActualPage;
        this.totalPages = this.get_total_pages();
        this.range();
      },
      resultsPerPage: function() { 
        this.resultsPerPage = this.getResultsPerPage;
        this.totalPages = this.get_total_pages();
        this.range();
      },
      totalResults: function() { 
        this.resultsPerPage = this.getResultsPerPage;
        this.totalPages = this.get_total_pages();
        this.range();
      }
    }
  }
</script>
